export default "__VITE_ASSET__r7F3$LEr__"